import { render, staticRenderFns } from "./goodsList.vue?vue&type=template&id=0f7d5f11&scoped=true&"
import script from "./goodsList.vue?vue&type=script&lang=ts&"
export * from "./goodsList.vue?vue&type=script&lang=ts&"
import style0 from "./goodsList.vue?vue&type=style&index=0&id=0f7d5f11&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7d5f11",
  null
  
)

export default component.exports